<div class="container animated fadeInRight">
  <app-lfsa-card [innTemplate]="Administrador" [titulo]="'Datos Administrador'" [efecto]="true"
    [colapseName]="'administrador'" [banderaColapse]='true'></app-lfsa-card>
  <ng-template #Administrador>
    <div class="row col-12">
      <div class="col-md-6">
        <h5><b>Nombres :</b>&nbsp;{{ dataUsuario.firstName }}</h5>
      </div>
      <div class="col-md-6">
        <h5><b>Apellidos :</b>&nbsp;{{  dataUsuario.lastName }}</h5>
      </div>
      <hr>
    </div>
  </ng-template>

  <div class="row">
    <div class="col-md-12">
      <button [routerLink]="['/indicadores-vivos/upload/csv'] " class="btn btn-primary btn-block btn-lg">Upload. CSV Presupuesto</button>
    </div>
  </div>
  <br>
  <div class="row">
    <div class="col-md-12">
      <button [routerLink]="['/indicadores-vivos/reporte-indicadores'] " class="btn btn-primary btn-block btn-lg">Reporte Presupuesto</button>
    </div>
  </div>
  <br>
  <div class="row">
    <div class="col-md-12">
      <button [routerLink]="['/indicadores-vivos/mantenedor-indicadores'] " class="btn btn-primary btn-block btn-lg">Mantenedor Presupuesto</button>
    </div>
  </div>
  
  
</div>